<script setup>
import { computed } from 'vue';
import ChannelIcon from 'dashboard/components-next/icon/ChannelIcon.vue';
import { useMapGetter } from 'dashboard/composables/store';
import { inboxOwnerName } from 'dashboard/constants/inboxOwnerMap';

const props = defineProps({
  inbox: {
    type: Object,
    default: () => {},
  },
});

const agents = useMapGetter('agents/getAgents');

// 动态: 按 created_by_id(创建者=归属客服)从 agents store 解析名字;
// 解析不到时退回 inboxOwnerMap 兜底, 再退回收件箱名。新加 inbox 无需改代码。
const displayName = computed(() => {
  const creator = props.inbox.created_by_id;
  const byCreator =
    creator && agents.value
      ? agents.value.find(a => a.id === creator)?.name
      : '';
  return byCreator || inboxOwnerName(props.inbox.id) || props.inbox.name;
});
</script>

<template>
  <div :title="displayName" class="flex items-center gap-0.5 min-w-0">
    <ChannelIcon :inbox="inbox" class="size-4 flex-shrink-0 text-n-slate-11" />
    <span class="truncate text-body-main text-n-slate-11">
      {{ displayName }}
    </span>
  </div>
</template>
